import { useQuery } from '@tanstack/react-query';

import { axiosPrivate } from 'app/utils';

export interface WebsiteSectionDetails {
  id: string;
  data: Record<string, unknown>;
  sectionType: {
    id: string;
    version: number;
    displayName: string;
    jsonSchema: Record<string, unknown>;
    uiSchema: Record<string, unknown>;
  };
}

export const websiteSectionDetailsQueryKey = (websiteId: string, sectionId: string) =>
  ['plus-website-section-details', { websiteId, sectionId }] as const;

async function fetchWebsiteSectionDetails(websiteId: string, sectionId: string) {
  const { data } = await axiosPrivate.get<WebsiteSectionDetails>(
    `/v3/pharmacist/plus-websites/${websiteId}/versions/preview/sections/${sectionId}`
  );
  return data;
}

export function useGetWebsiteSectionDetails({
  websiteId,
  sectionId,
}: {
  websiteId: string;
  sectionId: string;
}) {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: websiteSectionDetailsQueryKey(websiteId, sectionId),
    queryFn: () => fetchWebsiteSectionDetails(websiteId, sectionId),
    enabled: !!websiteId && !!sectionId,
    meta: { errorMessage: 'Failed to load section details' },
  });

  return { sectionDetails: data, isLoading, isError, error };
}
